module.exports = __webpack_public_path__ + "assets/img/join1.771240f8.png";